import React from "react";
import { Button, DropdownButton } from "components/ui";

const PageHeader = ({ title, buttons = [], icon, isDropdownButton = {} }) => {
  return (
    <div className="flex items-center justify-between mb-5 w-full">
      <div className="capitalize font-bold text-black md:text-2xl xs:text-base sm:text-xl flex w-full">
        <span className="mr-1" style={{ marginTop: "2px" }}>
          {icon}
        </span>
        <div className="w-full ">{title}</div>
      </div>
      <div className="flex w-full justify-end">
        {isDropdownButton?.option?.length && (
          <DropdownButton
            buttonLabel={isDropdownButton?.btnLabel}
            options={isDropdownButton?.option}
            onSelect={isDropdownButton?.handleOption}
          />
        )}

        {buttons?.map((btn, index) => {
          const component = (
            <Button
              key={index}
              size="sm"
              variant={btn?.variant || "solid"}
              type={btn?.type || "button"}
              onClick={(e) => btn?.onClick?.(btn?.key, e)}
              className="ml-2 capitalize"
              icon={btn.icon}
              disabled={btn?.disabled}
              loading={btn?.loading}
              style={{ ...btn.style }}
            >
              {btn.label}
            </Button>
          );
          if (btn?.key) {
            return component;
          } else return component;
        })}
      </div>
    </div>
  );
};

export default PageHeader;
